import { useTranslation } from 'react-i18next';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface RemoveInvalidGtinsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Number of items whose invalid GTIN will be cleared. */
  count: number;
  /** Called when the user confirms the removal. */
  onConfirm: () => void;
}

/**
 * Confirmation dialog shown before bulk-clearing the invalid GTINs of items
 * that still carry a SKU or a Shopify id (so the
 * `sku_or_gtin_or_shopify_variant_id` rule stays satisfied). Triggered from the
 * AlertSidebar "Invalid GTINs" section.
 */
export const RemoveInvalidGtinsDialog: React.FC<
  RemoveInvalidGtinsDialogProps
> = ({ open, onOpenChange, count, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('components.alert_sidebar.gtin_remove_confirm_title')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('components.alert_sidebar.gtin_remove_confirm_description', {
              count,
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('general.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            data-testid="remove-invalid-gtins-confirm"
            onClick={onConfirm}
          >
            {t('components.alert_sidebar.gtin_remove_cta')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
